import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';


export default function BasicCard({name, value, flag, flagSx}) {
  return (
    <Card sx={{ minWidth:190 }}>
      <CardContent>
        <Typography variant="h5" component="div">
            {name}
        </Typography>
        <Typography variant="h4">
          {value}
        </Typography>
        {flag ? (
          <Chip
            size="small"
            label={flag}
            sx={{ mt: 1, fontWeight: 700, ...flagSx }}
          />
        ) : null}
      </CardContent>
    </Card>
  );
}
